//根据页面访问域名判断区域
const getHostArea = () => {
    var host = document.domain;
    if (host == 'www.xzhouse.com.cn') {
        return '320300'; //主城区
    } else if (host == 'fx.xzhouse.com.cn') {
        return '320321';
    } else if (host == 'xy.xzhouse.com.cn') {
        return '320381';
    } else if (host == 'sn.xzhouse.com.cn') {
        return '320324';
    } else if (host == 'px.xzhouse.com.cn') {
        return '320322';
    } else if (host == 'pz.xzhouse.com.cn') {
        return '320382';
    } else {
        return '320300';
    }
};
const getHostDomain = () => {
    var area = this.main.getHostArea();
    if (area == '320300') {
        return 'https://www.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320321') {
        return 'https://fx.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320381') {
        return 'https://xy.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320324') {
        return 'https://sn.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320322') {
        return 'https://px.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320382') {
        return 'https://pz.xzhouse.com.cn/page/generation/onlinePc';
    } else {
        return 'https://www.xzhouse.com.cn/page/generation/onlinePc';
    }
};

const zhArea = (value) => {
    if (value == '320312') {
        return '铜山';
    } else if (value == '320321') {
        return '丰县';
    } else if (value == '320381') {
        return '新沂';
    } else if (value == '320324') {
        return '睢宁';
    } else if (value == '320') {
        return '市区';
    } else if (value == '320322') {
        return '沛县';
    } else if (value == '320382') {
        return '邳州';
    } else if (value == '320305') {
        return '贾汪';
    } else {
        return '错误区划代码';
    }
};

const getAreaName = (value) => {
    if (value == '320200') {
        return '主城区'; //主城区
    } else if (value == '320302') {
        return '鼓楼区';
    } else if (value == '320311') {
        return '泉山区';
    } else if (value == '320303') {
        return '云龙区';
    } else if (value == '320398') {
        return '开发区';
    } else if (value == '320312') {
        return '铜山区';
    } else if (value == '320399') {
        return '高新区';
    } else if (value == '320397') {
        return '港务区';
    } else if (value == '320305') {
        return '贾汪区';
    } else if (value == '320321') {
        return '丰县';
    } else if (value == '320381') {
        return '新沂市';
    } else if (value == '320324') {
        return '睢宁县';
    } else if (value == '320322') {
        return '沛县';
    } else if (value == '320382') {
        return '邳州市';
    } else {
        return '主城区';
    }
};

const zhXzqh = (data) => {
    if (data === "320302000000") {
        return "鼓楼区";
    } else if (data === "320311000000") {
        return "泉山区";
    } else if (data === "320303000000") {
        return "云龙区";
    } else if (data === "320398000000") {
        return "金山桥";
    } else if (data === "320312000000") {
        return "铜山区";
    } else if (data === "320305000000") {
        return "贾汪区";
    } else if (data === "320399000000") {
        return "高新区";
    } else if (data === "320397000000") {
        return "港务区";
    } else if (data === "320382000000") {
        return "邳州市";
    } else if (data === "320381000000") {
        return "新沂市";
    } else if (data === "320321000000") {
        return "丰县";
    } else if (data === "320324000000") {
        return "睢宁";
    } else if (data === "320322000000") {
        return "沛县";
    } else if (data === "320") {
        return "市区";
    }
};

const getAreaCode = (value) => {
    if (value == '主城区') {
        return '320200';
    } else if (value == '鼓楼区') {
        return '320302';
    } else if (value == '泉山区') {
        return '320311';
    } else if (value == '云龙区') {
        return '320303';
    } else if (value == '开发区') {
        return '320398';
    } else if (value == '铜山区') {
        return '320312';
    } else if (value == '高新区') {
        return '320399';
    } else if (value == '港务区') {
        return '320397';
    } else if (value == '贾汪区') {
        return '320305';
    } else if (value == '丰县') {
        return '320321';
    } else if (value == '新沂市') {
        return '320381';
    } else if (value == '睢宁县') {
        return '320324';
    } else if (value == '沛县') {
        return '320322';
    } else if (value == '邳州市') {
        return '320382';
    } else {
        return '320200';
    }
};

const getHostDomainByXzqh = (area) => {
    if (area == '320300') {
        return 'https://www.xzhouse.com.cn/page/generation/onlinePc'; //主城区
    } else if (area == '320321') {
        return 'https://fx.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320381') {
        return 'https://xy.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320324') {
        return 'https://sn.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320322') {
        return 'https://px.xzhouse.com.cn/page/generation/onlinePc';
    } else if (area == '320382') {
        return 'https://pz.xzhouse.com.cn/page/generation/onlinePc';
    } else {
        return 'https://www.xzhouse.com.cn/page/generation/onlinePc';
    }
}


module.exports = {
    getHostArea,
    getHostDomain,
    zhArea,
    zhXzqh,
    getAreaName,
    getAreaCode,
    getHostDomainByXzqh
}